import { render } from "./FloorPlanGalleryComponent.vue?vue&type=template&id=87370f4e"
import script from "./FloorPlanGalleryComponent.vue?vue&type=script&lang=js"
export * from "./FloorPlanGalleryComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twilkinson/Desktop/af3-shortcodes-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__